/* eslint-disable jsx-a11y/label-has-associated-control */
import { SetStateAction, useState, useCallback } from "react";
import { Input, Form, Button as AntButton, Select } from "antd";
import { Warning2 } from "iconsax-react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { createAtividade } from "../../hooks/module";
import useAdminGuard from "../../hooks/useAdminGuard";

import MobileLayout from "../../components/MobileLayout";
import { Main, Fieldset, Legend, Footer, BoxOp, InputCheckBox } from "./styles";

export interface atividadeProps {
  optionOne: string;
  optionTwo: string;
  optionThree: string;
  correctOption: string;
  link: string;
}

function AtvForm() {
  useAdminGuard();

  const [tipo, setTipo] = useState("");
  const [optionOne, setOptionOne] = useState("");
  const [optionTwo, setOptionTwo] = useState("");
  const [optionThree, setOptionThree] = useState("");
  const [correctOption, setCorrectOption] = useState("");
  const [link, setLink] = useState("");
  const [form] = Form.useForm();
  const [questions, setQuestions] = useState<atividadeProps[]>([]);
  const [saving, setSaving] = useState(false);
  const { state } = useLocation() as { state?: { uid?: string } };
  const navigate = useNavigate();
  const moduleId = state?.uid;

  const addAtv = useCallback((payload: atividadeProps) => {
    setQuestions((prev) => [...prev, payload]);
  }, []);

  const resetQuestionFields = () => {
    form.resetFields();
    setOptionOne("");
    setOptionTwo("");
    setOptionThree("");
    setCorrectOption("");
    setLink("");
  };

  const handleAddQuestion = () => {
    if (
      optionOne === "" ||
      optionTwo === "" ||
      optionThree === "" ||
      link === "" ||
      correctOption === ""
    ) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Preencha todas as opções, o vídeo e marque a resposta correta.",
      });
      return;
    }

    addAtv({
      optionOne,
      optionTwo,
      optionThree,
      correctOption,
      link,
    });
    resetQuestionFields();
  };

  const handleSave = async () => {
    if (!moduleId) {
      Swal.fire({
        icon: "error",
        title: "Módulo não informado",
        text: "Abra o formulário a partir dos detalhes do módulo.",
      });
      return;
    }
    if (questions.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhuma questão",
        text: "Adicione ao menos uma questão com o botão ADD antes de salvar.",
      });
      return;
    }

    setSaving(true);
    try {
      await createAtividade(questions, moduleId);
      await Swal.fire({
        icon: "success",
        title: "Atividade salva",
        text: "A atividade foi cadastrada no módulo.",
        timer: 1800,
        showConfirmButton: false,
      });
      navigate("/modules");
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Erro ao salvar",
        text: "Não foi possível cadastrar a atividade. Tente novamente.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <MobileLayout
      headerTitle="Nova Atividade"
      headerType="manager"
      showFooter={false}
    >
      <Main>
        <Form form={form} id="FormAtv">
          <Fieldset>
            <Legend>Dados da Atividade</Legend>
            <label htmlFor="select">Tipo de Atividade</label>
            <Select
              style={{ marginBottom: "1.6rem" }}
              placeholder="Selecione uma Opção"
              value={tipo !== "" ? tipo : undefined}
              onChange={(value) => {
                setTipo(value);
              }}
              options={[
                { value: "1", label: "Múltipla escolha" },
                { value: "2", label: "Com vídeo de referência" },
              ]}
            />
            <div>
              <p>
                Preencha os campos com as opções, e em seguida marque a opção
                correta
              </p>
              <BoxOp className="boxOp">
                <InputCheckBox className="inputCheckBox">
                  <Form.Item name="radioCorrect" valuePropName="checked">
                    <Input
                      name="radioCorrect"
                      className="radio"
                      style={{ width: "1.5rem", margin: "0 5px" }}
                      type="radio"
                      onChange={() => {
                        setCorrectOption(optionOne);
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="optionOne"
                    rules={[
                      {
                        required: true,
                        message: "Este campo é obrigatório",
                      },
                    ]}
                  >
                    <Input
                      name="optionOne"
                      style={{ margin: "0" }}
                      onChange={(e: {
                        target: { value: SetStateAction<string> };
                      }) => {
                        setOptionOne(e.target.value);
                      }}
                    />
                  </Form.Item>
                </InputCheckBox>
                <InputCheckBox className="inputCheckBox">
                  <Form.Item name="radioCorrect" valuePropName="checked">
                    <Input
                      name="radioCorrect"
                      className="radio"
                      style={{ width: "1.5rem", margin: "0 5px" }}
                      type="radio"
                      onChange={() => {
                        setCorrectOption(optionTwo);
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="optionTwo"
                    rules={[
                      {
                        required: true,
                        message: "Este campo é obrigatório",
                      },
                    ]}
                  >
                    <Input
                      name="optionTwo"
                      style={{ margin: "0" }}
                      onChange={(e: {
                        target: { value: SetStateAction<string> };
                      }) => {
                        setOptionTwo(e.target.value);
                      }}
                    />
                  </Form.Item>
                </InputCheckBox>
                <InputCheckBox className="inputCheckBox">
                  <Form.Item name="radioCorrect" valuePropName="checked">
                    <Input
                      name="radioCorrect"
                      className="radio"
                      style={{ width: "1.5rem", margin: "0 5px" }}
                      type="radio"
                      onChange={() => {
                        setCorrectOption(optionThree);
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="optionThree"
                    rules={[
                      {
                        required: true,
                        message: "Este campo é obrigatório",
                      },
                    ]}
                  >
                    <Input
                      name="optionThree"
                      style={{ margin: "0" }}
                      onChange={(e: {
                        target: { value: SetStateAction<string> };
                      }) => {
                        setOptionThree(e.target.value);
                      }}
                    />
                  </Form.Item>
                </InputCheckBox>
              </BoxOp>
              <p style={{ marginTop: "2rem" }}>Opção correta selecionada:</p>
              <InputCheckBox className="inputCheckBox">
                <Form.Item name="correctOption">
                  <Input
                    name="correctOption"
                    style={{ color: "black" }}
                    placeholder={correctOption}
                    disabled
                  />
                </Form.Item>
              </InputCheckBox>
            </div>

            <label htmlFor="link">Video de Referência</label>
            <Form.Item
              name="link"
              rules={[
                {
                  required: true,
                  message: "Este campo é obrigatório",
                },
              ]}
            >
              <Input
                name="link"
                onChange={(e: {
                  target: { value: SetStateAction<string> };
                }) => {
                  setLink(e.target.value);
                }}
                placeholder="Insira o link do para o video"
              />
            </Form.Item>

            <div className="botoes">
              <AntButton type="default" onClick={handleAddQuestion}>
                ADD
              </AntButton>
              <AntButton type="primary" loading={saving} onClick={handleSave}>
                Finalizar
              </AntButton>
            </div>
            {questions.length > 0 && (
              <p style={{ marginTop: "1rem" }}>
                {questions.length} questão(ões) pronta(s) para salvar
              </p>
            )}
          </Fieldset>
          <Footer>
            <p>
              <Warning2 size={48} />
              Atenção! <br />É necessário preencher todos os dados.
            </p>
            <AntButton type="primary" loading={saving} onClick={handleSave}>
              Salvar cadastro
            </AntButton>
          </Footer>
        </Form>
      </Main>
    </MobileLayout>
  );
}

export default AtvForm;
